import debounce from 'lodash.debounce'
import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

interface Props {
  defaultValues: any
  onSubmit: any
}

interface Props {
  defaultValues: any
  onSubmit: any
}

const AutoSave = React.memo(({ defaultValues, onSubmit }: Props) => {
  const methods = useFormContext()
  const watchedData = useWatch({
    control: methods.control,
    defaultValue: defaultValues,
  })

  const debouncedSave = React.useRef(
    debounce(() => {
      methods.handleSubmit(onSubmit)()
    }, 500),
  ).current

  useEffect(() => {
    if (methods.formState.isDirty) {
      debouncedSave()
    }

    return debouncedSave.cancel
  }, [debouncedSave, methods.formState.isDirty, watchedData])

  return null
})

export default AutoSave
